import { useParams, useNavigate } from "react-router-dom";
import { usePublicFormulario } from "@/hooks/usePublicFormulario";
import { FormularioRenderer } from "@/components/Formularios/FormularioRenderer";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle, CheckCircle2, Loader2 } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useState } from "react";

export default function PublicFormulario() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { formulario, campos, isLoading, error } = usePublicFormulario(token);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted flex items-center justify-center p-4">
        <Card className="w-full max-w-2xl">
          <CardContent className="flex flex-col items-center justify-center py-12">
            <Loader2 className="h-12 w-12 animate-spin text-primary mb-4" />
            <p className="text-muted-foreground">Carregando formulário...</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted flex items-center justify-center p-4">
        <Card className="w-full max-w-2xl">
          <CardContent className="py-12">
            <Alert variant="destructive">
              <AlertCircle className="h-5 w-5" />
              <AlertTitle>Erro</AlertTitle>
              <AlertDescription className="mt-2">
                {error.message}
              </AlertDescription>
            </Alert>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (!formulario || !campos) {
    return null;
  }

  if (submitSuccess) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted flex items-center justify-center p-4">
        <Card className="w-full max-w-2xl">
          <CardContent className="py-12 text-center">
            <CheckCircle2 className="h-16 w-16 text-green-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-2">Formulário enviado com sucesso!</h2>
            <p className="text-muted-foreground mb-6">
              Obrigado por preencher o formulário. Sua resposta foi registrada.
            </p>
            {formulario.permite_multiplas_respostas && (
              <Button onClick={() => setSubmitSuccess(false)}>
                Enviar outra resposta
              </Button>
            )}
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted p-2 sm:p-4 lg:p-6">
      <div className="max-w-full sm:max-w-2xl lg:max-w-3xl mx-auto py-4 sm:py-8 px-3 sm:px-4">
        {formulario.client?.name && (
          <div className="text-center mb-6">
            <p className="text-sm text-muted-foreground">{formulario.client.name}</p>
          </div>
        )}
        
        <FormularioRenderer
          formularioId={formulario.id}
          formularioTitulo={formulario.titulo}
          formularioDescricao={formulario.descricao}
          campos={campos}
          isPublic={true}
          allowAnonymous={formulario.permite_anonimo}
          onSubmitSuccess={() => setSubmitSuccess(true)}
          clientId={formulario.client_id}
        />
      </div>
    </div>
  );
}
